export const souvenirShops = {
  type: "FeatureCollection",
  name: "souvenir_shops",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        lat: 45.4353688,
        lng: 12.3366831,
        name: "Feelin' Venice",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.9,
        user_ratings_total: 57,
        place_id: "ChIJD-uQ_tmxfkcRajBObLwbQrM",
        price_level: 0,
        GRID_ID: "AP-21",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33668, 45.43537]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4329184,
        lng: 12.3387884,
        name: "Souvenir shop Turchetto",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.1,
        user_ratings_total: 8,
        place_id: "ChIJq0VeqNexfkcRmue5uEedqMc",
        price_level: 0,
        GRID_ID: "AR-24",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33879, 45.43292]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4376743,
        lng: 12.3195876,
        name: "Negozi di souvenir",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.7,
        user_ratings_total: 6,
        place_id: "ChIJx5_eFmmxfkcRZhTmsxET9Oo",
        price_level: 0,
        GRID_ID: "V-18",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31959, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.437405,
        lng: 12.338825,
        name: "Venice Souvenir Store",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.0,
        user_ratings_total: 2,
        place_id: "ChIJ5-KpdtmxfkcRm8dn1mdm-b0",
        price_level: 0,
        GRID_ID: "AR-18",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33882, 45.4374]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4316704,
        lng: 12.3207403,
        name: "Murano Glass Parrucciera",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJA_H1ElixfkcRrpmjlgtGhZ8",
        price_level: 0,
        GRID_ID: "W-26",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32074, 45.43167]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4365796,
        lng: 12.3199912,
        name: "Souvenir shop",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.0,
        user_ratings_total: 1,
        place_id: "ChIJsW-sL--xfkcRm2qZuhjh8UY",
        price_level: 0,
        GRID_ID: "V-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31999, 45.43658]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.43884,
        lng: 12.3344855,
        name: "Souvenire Store",
        types: ["point_of_interest", "store", "establishment"],
        rating: 1.0,
        user_ratings_total: 1,
        place_id: "ChIJP0fNDNuxfkcRF5ddwT16Q5E",
        price_level: 0,
        GRID_ID: "AM-15",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33449, 45.43884]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.441013,
        lng: 12.334829,
        name: "Souvenir Articoli da regalo La Sorella Alberto",
        types: ["point_of_interest", "store", "establishment"],
        rating: 3.0,
        user_ratings_total: 2,
        place_id: "ChIJr2BG796xfkcRi4ItSIjUjAk",
        price_level: 0,
        GRID_ID: "AM-12",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33483, 45.44101]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.434491,
        lng: 12.335903,
        name: "Venice Art",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 11,
        place_id: "ChIJ8X4LstCxfkcRAcRv38GHkNM",
        price_level: 0,
        GRID_ID: "AO-21",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3359, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.432708,
        lng: 12.337773,
        name: "Stella Souvenir di Bertolini Simone",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.5,
        user_ratings_total: 2,
        place_id: "ChIJq28HadyxfkcRIpW4s1pNTBM",
        price_level: 0,
        GRID_ID: "AQ-24",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33777, 45.43271]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4435047,
        lng: 12.325222,
        name: "Venice Fashion",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.9,
        user_ratings_total: 12,
        place_id: "ChIJQ6PJqcGxfkcRXhk8Apv43iw",
        price_level: 0,
        GRID_ID: "AB-10",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32522, 45.4435]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4388608,
        lng: 12.3347613,
        name: "Az Souvenir Venezia",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJLzXEdNuxfkcRirQuShVtETc",
        price_level: 0,
        GRID_ID: "AM-15",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33476, 45.43886]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4366311,
        lng: 12.3283813,
        name: "Cenerentola di Simonato Martina Venezia",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJsQptx1uxfkcRbfpIktS4nJo",
        price_level: 0,
        GRID_ID: "AF-19",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32838, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4390055,
        lng: 12.3234827,
        name: "Ceramiche & Grafica di Margherita Rossetto",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 7,
        place_id: "ChIJI4R_98axfkcR1JSPEUd48ZE",
        price_level: 0,
        GRID_ID: "Z-16",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32348, 45.43901]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4361599,
        lng: 12.3279939,
        name: "Euro Venice",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.7,
        user_ratings_total: 7,
        place_id: "ChIJd7mafsWxfkcRbj-pFCiLlZI",
        price_level: 0,
        GRID_ID: "AF-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32799, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4405624,
        lng: 12.3241912,
        name: '"Al Veliero" di Zara Fabio',
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJuTHFxMaxfkcRAg6Bujo5d7g",
        price_level: 0,
        GRID_ID: "AA-13",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32419, 45.44056]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4356178,
        lng: 12.338997,
        name: "Noor Souvenir di Islam Rafiqul",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 2,
        place_id: "ChIJVxDQDz-xfkcRGDBh3Ytt2JE",
        price_level: 0,
        GRID_ID: "AR-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.339, 45.43562]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4317831,
        lng: 12.3260576,
        name: "Toletta Glass Venezia",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 6,
        place_id: "ChIJ3RYmfM6xfkcRf12IiClVSQ8",
        price_level: 0,
        GRID_ID: "AD-26",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32606, 45.43178]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4338294,
        lng: 12.3307086,
        name: "Abid Nahar Souvenir",
        types: ["point_of_interest", "store", "establishment"],
        rating: 3.0,
        user_ratings_total: 1,
        place_id: "ChIJJ-Eq_XexfkcRsWAQ_7We3dY",
        price_level: 0,
        GRID_ID: "AI-23",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33071, 45.43383]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4357909,
        lng: 12.3361156,
        name: "Atelier Casanova",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 3,
        place_id: "ChIJe_k0WdCxfkcR0RGGsFRwPWk",
        price_level: 0,
        GRID_ID: "AO-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33612, 45.43579]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4328341,
        lng: 12.3251093,
        name: "Mijoy",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 2,
        place_id: "ChIJHxF2686xfkcRMphVE3_67T0",
        price_level: 0,
        GRID_ID: "AB-25",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32511, 45.43283]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4396842,
        lng: 12.3376567,
        name: "Souvenir di Rahman Md M",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJi7SKzGqxfkcRzueoFY-2Hfw",
        price_level: 0,
        GRID_ID: "AQ-14",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33766, 45.43968]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4409697,
        lng: 12.3349528,
        name: "Feelin' Venice",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 32,
        place_id: "ChIJ_0QSJRaxfkcRGMKaFuZyHdU",
        price_level: 0,
        GRID_ID: "AM-12",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33495, 45.44097]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4369645,
        lng: 12.3292398,
        name: "Vianello Alvise",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.7,
        user_ratings_total: 18,
        place_id: "ChIJYXFBa8WxfkcR4MehU4jAJMg",
        price_level: 0,
        GRID_ID: "AG-18",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32924, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4422483,
        lng: 12.3236713,
        name: "Mohammad Abdul Kuddus",
        types: ["storage", "point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJW-oEcXCxfkcRu-rwWEQs_fk",
        price_level: 0,
        GRID_ID: "Z-11",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32367, 45.44225]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.433353,
        lng: 12.336642,
        name: "Souvenir Guetta Sas Di G. Guetta E C.",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.0,
        user_ratings_total: 1,
        place_id: "ChIJA3f0OtexfkcRvc2Pk1-yVeI",
        price_level: 0,
        GRID_ID: "AP-24",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33664, 45.43335]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4321339,
        lng: 12.3253529,
        name: "Ca'Macana",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.7,
        user_ratings_total: 10,
        place_id: "ChIJ2SNFj86xfkcRSFOEhgMyADM",
        price_level: 0,
        GRID_ID: "AC-25",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32535, 45.43213]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4371996,
        lng: 12.3310667,
        name: "bottega degli zanni",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJG2r9ytqxfkcRZ-CHjfNcOo4",
        price_level: 0,
        GRID_ID: "AI-18",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33107, 45.4372]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4353163,
        lng: 12.3378692,
        name: "Souvenir S.n.c. di Zanchi Roberta e Savarese Giuseppina",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJL1B159mxfkcRBIS9H6OcSgc",
        price_level: 0,
        GRID_ID: "AQ-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33787, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.436019,
        lng: 12.338498,
        name: "Franca Girl's Mask atelier",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.4,
        user_ratings_total: 36,
        place_id: "ChIJCe31v9mxfkcRQJ0cYEbVx8g",
        price_level: 0,
        GRID_ID: "AR-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3385, 45.43602]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4368594,
        lng: 12.3289913,
        name: "S&J Glass of Venice",
        types: ["point_of_interest", "store", "establishment"],
        rating: 3.0,
        user_ratings_total: 2,
        place_id: "ChIJ_Uek2maxfkcRB8akWFvjtC8",
        price_level: 0,
        GRID_ID: "AG-18",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32899, 45.43686]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4405215,
        lng: 12.3249579,
        name: "ex. Solo Perle Dg",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJW5AbucaxfkcRXACp8fVbA7M",
        price_level: 0,
        GRID_ID: "AB-14",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32496, 45.44052]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4352629,
        lng: 12.3367906,
        name: "Sole Luna",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJpZMpuMKxfkcRaFLccOOpa_Y",
        price_level: 0,
        GRID_ID: "AP-21",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33679, 45.43526]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4351935,
        lng: 12.3353368,
        name: "e-Consulenze",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 6,
        place_id: "ChIJc5ruNdexfkcRTjYnfZSeWrg",
        price_level: 0,
        GRID_ID: "AN-21",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33534, 45.43519]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4350233,
        lng: 12.3390795,
        name: "Maglie Veneziane srl",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJnZaw1tmxfkcRCCYEth0X21I",
        price_level: 0,
        GRID_ID: "AR-21",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33908, 45.43502]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4360553,
        lng: 12.3443009,
        name: "negozio souvenirs Sartori Vittorio",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJs5tSqgevfkcRN29WWse2FPs",
        price_level: 0,
        GRID_ID: "AY-19",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3443, 45.43606]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4341967,
        lng: 12.3372077,
        name: "Venicemask",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.0,
        user_ratings_total: 1,
        place_id: "ChIJDfF7RNexfkcR9cldiqkLFTo",
        price_level: 0,
        GRID_ID: "AQ-22",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33721, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4359757,
        lng: 12.3386341,
        name: "La girandola Venezia",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJu-ch-TCxfkcRHMkxHTcH6Kw",
        price_level: 0,
        GRID_ID: "AR-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33863, 45.43598]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4450101,
        lng: 12.3267778,
        name: "David's Place",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.5,
        user_ratings_total: 2,
        place_id: "ChIJb2XHwsGxfkcR3R78S7zxAx8",
        price_level: 0,
        GRID_ID: "AD-7",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.44501]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.43375,
        lng: 12.34684,
        name: "Manfe Marco",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJsWG520mvfkcRs0-WYs9FQLQ",
        price_level: 0,
        GRID_ID: "BB-23",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34684, 45.43375]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4339171,
        lng: 12.3419838,
        name: "La Barchessa s.n.c.",
        types: ["point_of_interest", "store", "establishment"],
        rating: 3.8,
        user_ratings_total: 4,
        place_id: "ChIJyQx4aNexfkcRD9uSGnnR-4g",
        price_level: 0,
        GRID_ID: "AV-23",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34198, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4378498,
        lng: 12.3362147,
        name: "Hard Rock Cafe Rock Shop",
        types: [
          "restaurant",
          "food",
          "point_of_interest",
          "store",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 263,
        place_id: "ChIJzanRyduxfkcR6JfyCuEsaSw",
        price_level: 0,
        GRID_ID: "AO-17",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33621, 45.43785]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.435247,
        lng: 12.337984,
        name: "San Marco 801",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.9,
        user_ratings_total: 17,
        place_id: "ChIJ2w5a0dmxfkcRsSMCn56_zdc",
        price_level: 0,
        GRID_ID: "AQ-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33798, 45.43525]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4387997,
        lng: 12.334177,
        name: "Baccalà Veneto",
        types: ["food", "point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 6,
        place_id: "ChIJjVcTx-uxfkcR4iFbOk8P6hg",
        price_level: 0,
        GRID_ID: "AM-15",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33418, 45.4388]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4340342,
        lng: 12.3455384,
        name: "Venetian souvenir shop",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJVVoRhOOvfkcR4bRl4MQQU-Q",
        price_level: 0,
        GRID_ID: "AZ-22",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34554, 45.43403]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4368126,
        lng: 12.3345995,
        name: "welcome on board di foto rialto souvenir snc",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 6,
        place_id: "ChIJZVADX9qxfkcR8HRasMuIOOI",
        price_level: 0,
        GRID_ID: "AM-18",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3346, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4371377,
        lng: 12.3394581,
        name: "Souvenir",
        types: ["store", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJy7jRCdmxfkcRZ06r73c1k0U",
        price_level: 0,
        GRID_ID: "AS-18",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33946, 45.43714]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4398311,
        lng: 12.3398006,
        name: "The Venetians Gift Bazaar",
        types: [
          "clothing_store",
          "point_of_interest",
          "store",
          "establishment",
        ],
        rating: 4.0,
        user_ratings_total: 1,
        place_id: "ChIJNa7qtt6xfkcRcz90Hg2cIkM",
        price_level: 0,
        GRID_ID: "AS-14",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3398, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4408229,
        lng: 12.3352042,
        name: "Cheap Souvenir Clothes",
        types: [
          "clothing_store",
          "point_of_interest",
          "store",
          "establishment",
        ],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJXaOrgFSxfkcR0x4zjmkiNB8",
        price_level: 0,
        GRID_ID: "AN-13",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3352, 45.44082]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4332788,
        lng: 12.3364358,
        name: "Beni Orietta",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJ6RS7AgSxfkcRTJUghR1wJV4",
        price_level: 0,
        GRID_ID: "AP-24",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33644, 45.43328]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4451164,
        lng: 12.3267866,
        name: "David's Shop",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 5,
        place_id: "ChIJNU6ZYoyxfkcRKgxeCSPtNF8",
        price_level: 0,
        GRID_ID: "AD-7",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32679, 45.44512]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4364379,
        lng: 12.3286156,
        name: "Martina Fantuzzo",
        types: ["point_of_interest", "store", "establishment"],
        rating: 5.0,
        user_ratings_total: 3,
        place_id: "ChIJ22InAVexfkcRC3wXlIjAp-Q",
        price_level: 0,
        GRID_ID: "AF-19",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32862, 45.43644]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.435492,
        lng: 12.3392512,
        name: "TREVISAN",
        types: ["point_of_interest", "store", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJ1zh7qdGxfkcRTfaOsLqxk-A",
        price_level: 0,
        GRID_ID: "AS-20",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33925, 45.43549]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4350446,
        lng: 12.3376575,
        name: "Frizzi e Lazzi snc",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.9,
        user_ratings_total: 8,
        place_id: "ChIJHex44dmxfkcRmrieu5MZWfY",
        price_level: 0,
        GRID_ID: "AQ-21",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33766, 45.43504]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4338355,
        lng: 12.3390018,
        name: "TREVISAN",
        types: ["point_of_interest", "store", "establishment"],
        rating: 4.8,
        user_ratings_total: 6,
        place_id: "ChIJW5p6LtixfkcRAYUOdiSPYsI",
        price_level: 0,
        GRID_ID: "AS-22",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.339, 45.43384]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4350071,
        lng: 12.3420732,
        name: "Magic Venice Carnival",
        types: [
          "hair_care",
          "home_goods_store",
          "point_of_interest",
          "clothing_store",
          "store",
          "establishment",
        ],
        rating: 4.8,
        user_ratings_total: 36,
        place_id: "ChIJ61lLBdixfkcR2X63a6rGu98",
        price_level: 0,
        GRID_ID: "AV-21",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34207, 45.43501]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4420609,
        lng: 12.3378399,
        name: "Antica Murrina Venezia & Atelier Voltolina",
        types: [
          "jewelry_store",
          "home_goods_store",
          "point_of_interest",
          "store",
          "establishment",
        ],
        rating: 2.0,
        user_ratings_total: 3,
        place_id: "ChIJ6dRJ6tmxfkcRNL8K_kTZ-dw",
        price_level: 0,
        GRID_ID: "AP-11",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33784, 45.44206]] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4372388,
        lng: 12.3393777,
        name: "Dolcetta Aldo Mobili D'Arte",
        types: [
          "general_contractor",
          "point_of_interest",
          "store",
          "establishment",
        ],
        rating: 5.0,
        user_ratings_total: 12,
        place_id: "ChIJ0XC2C9qxfkcR0QpluizRy1I",
        price_level: 0,
        GRID_ID: "AS-17",
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33938, 45.43724]] },
    },
  ],
};
